// packages
import { feature, mesh } from 'topojson-client';

/**
 * Transform a TopoJSON object into GeoJSON
 * @param {import('topojson-specification').Topology} topology
 * @param {string[]} keys
 * @returns {import('../types').MapLayer[]}
 */
export function topojsonToGeoJson(topology, keys) {
  const geojson = [];

  for (let idx = 0; idx < keys.length; idx++) {
    const key = keys[idx];
    const objects = topology.objects[key];

    geojson.push({
      // every layer in the map file is a GeometryCollection, so this is a FeatureCollection
      bounds: /** @type {GeoJSON.FeatureCollection} */ (
        feature(topology, objects)
      ),
      borders: mesh(
        topology,
        /** @type {import('topojson-specification').GeometryObject} */ (
          objects
        ),
        (a, b) => a !== b
      ),
    });
  }

  return geojson;
}
